import React from "react";
import { Steps, Button, Select, message } from "antd";

import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";

const Step = Steps.Step;
const Option = Select.Option;

class NewAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0
    };
  }

  next = () => {
    const current = this.state.current + 1;
    this.setState({ current });
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };

  render() {
    const steps = [
      {
        title: "Select case and control samples",
        content: <StepOne />
      },
      {
        title: "Focus the analysis",
        content: <StepTwo />
      },
      {
        title: "Define Annotations",
        content: <StepThree />
      },
      {
        title: "Review and finalize",
        content: <StepFour />
      }
    ];
    
    const { onCancel } = this.props;
    const { current } = this.state;

    let percent;
    switch (this.state.current) {
      case 1:
        percent = 50;
        break;
      case 2:
        percent = 75;
        break;
      case 3:
        percent = 95;
        break;
      default:
        percent = 25;
    }
    return (
      <div className="analysis">
        <div className="analysis__title">Create analysis</div>
        <Steps className="analysis__steps" current={current}>
          {steps.map(item => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div className="analysis__content">{steps[current].content}</div>
        <div className="analysis__progress">
          <div className="analysis__percent" style={{ width: percent + "%" }} />
        </div>
        <div className="analysis__foot">
          <div className="analysis__group">
            <div className="analysis__text">
              Use samples from reference genome
            </div>
            <Select className="ant-select-bg" defaultValue="1">
              <Option value="1">Keep only</Option>
            </Select>
          </div>
          <div className="analysis__actions analysis__actions_left">
            <Button className="ant-btn-no-border">
              Load from prior analysis
            </Button>
            <Button className="ant-btn-no-border">Use library</Button>
          </div>
          <div className="analysis__actions">
            {current > 0 && (
              <Button
                type="secondary"
                onClick={this.prev}
                style={{ marginRight: 16 }}
              >
                Back
              </Button>
            )}
            {current === 0 && (
              <Button
                type="secondary"
                onClick={onCancel}
                style={{ marginRight: 16 }}
              >
                Back
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" onClick={this.next}>
                Next
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button
                type="primary"
                onClick={() => message.success("Processing complete!")}
              >
                Analyze
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default NewAnalysis;
